export default __webpack_public_path__ + "static/media/SETSum.017d7ccf.gif";